export { ProposalOutflowsSectionContainer } from './ProposalOutflowsSectionContainer';
export { ProposalOutflowsSection } from './ProposalOutflowsSection';
